import * as actions from './actions';
import reducers from './reducer';

export const App = { actions, reducers };
export { AppState } from './reducer';
